// Mock Sales Data - İNSANET
// Daire satışları ve gelir takibi verileri

export const mockSales = [
    {
        id: 'sale-1',
        apartmentNo: 'A-3',
        blockName: 'A Blok',
        buyer: 'Ahmet Yılmaz',
        buyerId: 'ind-1',
        saleDate: '2025-07-15',
        totalPrice: 2400000,
        downPayment: 500000,
        installmentCount: 38,
        installmentAmount: 50000,
        totalPaid: 550000,
        totalRemaining: 1850000,
        status: 'active',
        constructionId: 'c1',
    },
    {
        id: 'sale-2',
        apartmentNo: 'A-5',
        blockName: 'A Blok',
        buyer: 'Fatma Demir',
        buyerId: 'ind-2',
        saleDate: '2025-07-20',
        totalPrice: 2800000,
        downPayment: 800000,
        installmentCount: 32,
        installmentAmount: 60000,
        totalPaid: 1040000,
        totalRemaining: 1760000,
        status: 'active',
        constructionId: 'c1',
    },
    {
        id: 'sale-3',
        apartmentNo: 'B-2',
        blockName: 'B Blok',
        buyer: 'Mehmet Kaya',
        buyerId: 'ind-3',
        saleDate: '2025-08-05',
        totalPrice: 2250000,
        downPayment: 450000,
        installmentCount: 40,
        installmentAmount: 45000,
        totalPaid: 630000,
        totalRemaining: 1620000,
        status: 'active',
        constructionId: 'c1',
    },
    {
        id: 'sale-4',
        apartmentNo: 'B-4',
        blockName: 'B Blok',
        buyer: 'Ayşe Öztürk',
        buyerId: 'ind-4',
        saleDate: '2025-09-01',
        totalPrice: 3500000,
        downPayment: 1100000,
        installmentCount: 30,
        installmentAmount: 80000,
        totalPaid: 1340000,
        totalRemaining: 2160000,
        status: 'active',
        constructionId: 'c2',
    },
    {
        id: 'sale-5',
        apartmentNo: 'C-1',
        blockName: 'C Blok',
        buyer: 'Ali Çelik',
        buyerId: 'ind-5',
        saleDate: '2025-07-10',
        totalPrice: 2200000,
        downPayment: 400000,
        installmentCount: 32,
        installmentAmount: 55000,
        totalPaid: 510000,
        totalRemaining: 1690000,
        status: 'overdue',
        constructionId: 'c1',
    },
    {
        id: 'sale-6',
        apartmentNo: 'B-6',
        blockName: 'B Blok',
        buyer: 'Zeynep Arslan',
        buyerId: 'ind-6',
        saleDate: '2025-07-18',
        totalPrice: 2400000,
        downPayment: 480000,
        installmentCount: 40,
        installmentAmount: 48000,
        totalPaid: 768000,
        totalRemaining: 1632000,
        status: 'active',
        constructionId: 'c1',
    },
    // --- Yeni Veriler ---
    { id: 'sale-7', apartmentNo: 'C-2', blockName: 'C Blok', buyer: 'Mustafa Şahin', buyerId: 'ind-7', saleDate: '2025-08-22', totalPrice: 2100000, downPayment: 400000, installmentCount: 30, installmentAmount: 56666, totalPaid: 513332, totalRemaining: 1586668, status: 'active', constructionId: 'c1' },
    { id: 'sale-8', apartmentNo: 'A-8', blockName: 'A Blok', buyer: 'Elif Erdoğan', buyerId: 'ind-8', saleDate: '2025-09-11', totalPrice: 3200000, downPayment: 800000, installmentCount: 40, installmentAmount: 60000, totalPaid: 920000, totalRemaining: 2280000, status: 'active', constructionId: 'c2' },
    { id: 'sale-9', apartmentNo: 'C-3', blockName: 'C Blok', buyer: 'Hüseyin Yıldız', buyerId: 'ind-9', saleDate: '2025-07-25', totalPrice: 2300000, downPayment: 500000, installmentCount: 36, installmentAmount: 50000, totalPaid: 650000, totalRemaining: 1650000, status: 'active', constructionId: 'c1' },
    { id: 'sale-10', apartmentNo: 'B-9', blockName: 'B Blok', buyer: 'Selin Koç', buyerId: 'ind-10', saleDate: '2025-08-30', totalPrice: 2900000, downPayment: 900000, installmentCount: 40, installmentAmount: 50000, totalPaid: 1050000, totalRemaining: 1850000, status: 'active', constructionId: 'c2' },
    { id: 'sale-11', apartmentNo: 'A-10', blockName: 'A Blok', buyer: 'Kemal Yılmaz', buyerId: 'ind-11', saleDate: '2025-09-15', totalPrice: 2600000, downPayment: 600000, installmentCount: 40, installmentAmount: 50000, totalPaid: 750000, totalRemaining: 1850000, status: 'active', constructionId: 'c1' },
    { id: 'sale-12', apartmentNo: 'B-12', blockName: 'B Blok', buyer: 'Burcu Deniz', buyerId: 'ind-12', saleDate: '2025-10-01', totalPrice: 3100000, downPayment: 1000000, installmentCount: 30, installmentAmount: 70000, totalPaid: 1210000, totalRemaining: 1890000, status: 'active', constructionId: 'c2' },
    { id: 'sale-13', apartmentNo: 'C-5', blockName: 'C Blok', buyer: 'Okan Kılıç', buyerId: 'ind-13', saleDate: '2025-10-10', totalPrice: 2150000, downPayment: 350000, installmentCount: 36, installmentAmount: 50000, totalPaid: 500000, totalRemaining: 1650000, status: 'overdue', constructionId: 'c1' },
    { id: 'sale-14', apartmentNo: 'A-15', blockName: 'A Blok', buyer: 'Merve Korkmaz', buyerId: 'ind-14', saleDate: '2025-11-05', totalPrice: 3700000, downPayment: 1200000, installmentCount: 50, installmentAmount: 50000, totalPaid: 1350000, totalRemaining: 2350000, status: 'active', constructionId: 'c2' },
    { id: 'sale-15', apartmentNo: 'B-18', blockName: 'B Blok', buyer: 'Cem Altun', buyerId: 'ind-15', saleDate: '2025-12-01', totalPrice: 4000000, downPayment: 1500000, installmentCount: 50, installmentAmount: 50000, totalPaid: 1700000, totalRemaining: 2300000, status: 'active', constructionId: 'c2' },
    { id: 'sale-16', apartmentNo: 'C-8', blockName: 'C Blok', buyer: 'Derya Şen', buyerId: 'ind-16', saleDate: '2025-12-15', totalPrice: 2400000, downPayment: 400000, installmentCount: 40, installmentAmount: 50000, totalPaid: 550000, totalRemaining: 1850000, status: 'active', constructionId: 'c1' },
];

// Helper fonksiyonlar
export const getSalesByConstructionId = (constructionId) => {
    if (!constructionId) {
        return mockSales;
    }
    return mockSales.filter(sale => sale.constructionId === constructionId);
};

// İstatistikler
export const getSalesStats = (sales) => {
    return {
        totalSales: sales.reduce((sum, s) => sum + s.totalPrice, 0),
        totalPaid: sales.reduce((sum, s) => sum + s.totalPaid, 0),
        totalRemaining: sales.reduce((sum, s) => sum + s.totalRemaining, 0),
        apartmentCount: sales.length,
        overdueCount: sales.filter(s => s.status === 'overdue').length,
    };
};

export default mockSales;
